import React, { Component } from 'react'
import './OnlineFilter.css'

class OnlineFilter extends Component
{
    render() {
        return (
            <div className='onlineFilterContainer'>
                <div className='onoffswitch'>
                    <input id='onlinefilterlabel' type='checkbox' defaultChecked={this.props.currentState} key={!this.props.currentState} ref={'onlineFilter'} onChange={()=>this.props.onlineFilterChange(this.refs.onlineFilter.checked)}/>
                    <label htmlFor='onlinefilterlabel' ><strong>Online</strong></label>
                </div>
            </div>
        );
    }
}

export default OnlineFilter


// WEBPACK FOOTER //
// ./src/components/OnlineFilter.js